import React from 'react';
import { useDropzone } from 'react-dropzone';
import { DropZoneContainer, DropZoneTitle } from './styled';
import { PhotoCamera } from '@material-ui/icons/';
function ImageDropZone(props) {
  const { getRootProps, getInputProps } = useDropzone();

  // const fileList = (files: FileWithPath[]): ReactNode => (
  //   files.map(file => (
  //     <li key={file.path}>
  //       {file.path} - {file.size} bytes
  //     </li>
  //   ))
  // );

  return (
    <DropZoneContainer>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input type="file" {...getInputProps()} />
        <DropZoneTitle><PhotoCamera /> Add image</DropZoneTitle>
        <span>Drag 'n' drop some files here, or click to select files</span>
      </div>
    </DropZoneContainer>
  );
}

export default ImageDropZone;
